import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useLink } from '../../../../common/hooks/useLinkHook';

const Footer = () => {
  const { linkObj } = useLink([
    'ChatDOC_Policy',
    'ChatDOC_Terms',
    'ChatDOC_Twitter',
    'ChatDOC_Discord',
    'ChatDOC_Blog',
    'ChatDOC_Changelog',
  ]);

  const FAQS_FOOTER_LINK = [
    {
      name: 'Policy',
      link: linkObj['ChatDOC_Policy'],
    },
    {
      name: 'Terms',
      link: linkObj['ChatDOC_Terms'],
    },
    {
      name: 'Twitter',
      link: linkObj['ChatDOC_Twitter'],
    },
    {
      name: 'Discord',
      link: linkObj['ChatDOC_Discord'],
    },
    {
      name: 'Blog',
      link: linkObj['ChatDOC_Blog'],
    },
    {
      name: 'Changelog',
      link: linkObj['ChatDOC_Changelog'],
    },
  ];

  return (
    <div className="footer-wrapper">
      <StaticImage
        src="../assets/images/footer-bg.png"
        className="footer-bg"
        alt="footer-bg"
      />
      {FAQS_FOOTER_LINK.map((item, index) => (
        <React.Fragment key={index}>
          <a
            href={item.link}
            target="_blank"
            rel="noreferrer"
            className="footer-link">
            {item.name}
          </a>
          <span className="footer-point"> · </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Footer;
